import { useTheme } from 'styled-components'

import { NativePlatform, WebPlatform } from '@/capacitor/components/native-platform/NativePlatform'
import { FlexRow } from '../../layout/flex/Flex'
import { H2 } from '../../typography/Heading'
import { StProgress, StProgressTextContainer } from './AppHeader.styled'

import type { ProgressBarProps } from '../../progress/ProgressBar.types'

type Props = {
  text?: string
  progress: ProgressBarProps
}

const AppHeaderProgressText = ({ text, progress }: Props) => {
  const theme = useTheme()
  return (
    <StProgressTextContainer>
      <WebPlatform>
        <FlexRow gap={theme.UI.Spacing.Space3}>
          {text ? (
            <H2 textAlign='center' noMargin>
              {text}
            </H2>
          ) : null}
          <StProgress type='BodyMediumBold'>{`${progress.value} / ${progress.max}`}</StProgress>
        </FlexRow>
      </WebPlatform>
      <NativePlatform>
        <StProgress type='BodyMediumBold'>{`${progress.value} / ${progress.max}`}</StProgress>
      </NativePlatform>
    </StProgressTextContainer>
  )
}

export { AppHeaderProgressText }
